module.exports = __webpack_public_path__ + "img/c36.19617743.png";